import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
    DataGrid,
    GridToolbarQuickFilter,
    GridToolbarContainer
} from '@mui/x-data-grid';

import DatabaseService from "../../services/database.service.js";
import { getBootstrapColors } from '../race/RaceColors.js';

import gridSxStyle from "../../common/GridSxStyles.js";

const TrackGrid = React.memo(({ circuitList, loadData, updateCircuitStatus, resetSelectedCircuit, isDesktop }) => {

    console.log("TrackGrid / refresh");

    const [selectCircuit, setSelectCircuit] = useState(undefined);
    // const DEFAULT_PAGINATION_MODEL = { pageSize: isDesktop ? 14 : 10 }
    // const DEFAULT_FILTER_MODEL = { filterModel: { items: [] } };
    // const [devicesPaginationModel, setDevicesPaginationModel] = useState(DEFAULT_PAGINATION_MODEL);
    // const [devicesFilterModel, setDevicesFilterModel] = useState(DEFAULT_FILTER_MODEL);
    const [contentData, setContentData] = useState(circuitList);

    const getCircuitStatusStr = (status) => {
        let text = '';
        let color = '';

        if (status === 0) {
            text = "Pending";
            color = "orange"; // You can customize the color as needed
        } else if (status === 1) {
            text = "Active";
            color = "#00BB00"; // You can customize the color as needed
        } else if (status === 2) {
            text = "Rejected";
            color = "red"; // You can customize the color as needed
        }

        return <span style={{ color: color }}>{text}</span>;
    };


    const processRowUpdate = React.useCallback(
        async (newRow) => {
            console.log("processRowUpdate", newRow);
            const payload = {
                name: newRow.name
            }
            const response = await DatabaseService.editCircuit(newRow.id, payload);

            if (response.status === 204) {
                toast.success("Name edited successfully", {
                    position: "bottom-right",
                    autoClose: 2000
                });

                const updatedRows = contentData.map((item) => {
                    if (item.id === newRow.id) {
                        return {
                            ...item,
                            name: newRow.name
                        };
                    }
                    return item;
                });

                setContentData(updatedRows); // Update the state

            } else {
                toast.error("Error editing the name", {
                    position: "bottom-right",
                    autoClose: 2000
                });
            }
            return response;
        },
        [contentData, setContentData]
    );

    useEffect(() => {
        setContentData(circuitList);
    }, [circuitList]);


    useEffect(() => {
        setSelectCircuit(undefined);
    }, [resetSelectedCircuit]);

    const columns = [
        {
            field: 'actions', headerName: '',
            width: "80",
            resizable: false,
            renderCell: ({ row }) => (
                <div style={{ textAlign: 'center' }}>
                    <i className={`fa fa-play`}
                        style={{
                            padding: "5px",
                            color: row.id === selectCircuit ? getBootstrapColors()[0] : "",
                            width: 20,
                        }}
                        onClick={() => {
                            setSelectCircuit(row.id);
                            loadData(row.id);
                        }}
                    />
                    <i className="fa fa-check" style={{ padding: "5px" }} onClick={() => { updateCircuitStatus(row.id, 1); }}></i>
                    <i className="fa fa-ban" style={{ padding: "5px" }} onClick={() => { updateCircuitStatus(row.id, 2); }}></i>
                </div>
            )
        },
        {
            field: 'country_code', headerName: 'Country',
            width: "30",
            // flex: 1,
        },
        {
            field: 'name', headerName: 'Name',
            flex: 1,
            editable: true,
        },
        {
            field: 'status', headerName: 'Status',
            flex: 1,
            resizable: false,
            renderCell: ({ row }) => (
                getCircuitStatusStr(row.status)
            )
        }
    ];

/*
    const handleFilterModelChange = (filterModel) => {
        setDevicesFilterModel(filterModel);
    };

    const handlePaginationModelChange = (paginationModel) => {
        setDevicesPaginationModel({
            page: paginationModel.page,
            pageSize: paginationModel.pageSize
        });
    }
*/

    const TableToolbar = (props) => {
        return (
            <GridToolbarContainer>
                <GridToolbarQuickFilter debounceMs={500} />
            </GridToolbarContainer>
        );
    };


    return (
        <DataGrid
            key={Math.random()}
            processRowUpdate={processRowUpdate}
            //          onProcessRowUpdateError={handleProcessRowUpdateError}
            disableVirtualization
            disableRowSelectionOnClick
            disableDensitySelector
            columnHeaderHeight={35}
            rowHeight={30}
            rows={contentData}
            columns={columns.map((column) => ({ ...column /*, loadData: loadData*/ }))}
            //loadData={loadData}
            //removeData={removeData}
            //initialState={{
            // ...dataConfig.initialState,
            //pagination: { paginationModel: devicesPaginationModel },
            //filter: { filterModel: devicesFilterModel },
            //}}
            //filterModel={devicesFilterModel.filterModel}
            //onPaginationModelChange={handlePaginationModelChange}
            //onFilterModelChange={handleFilterModelChange}
            slots={{ toolbar: TableToolbar }}
            slotProps={{
                toolbar: {
                    showQuickFilter: true,
                    showExport: false,
                    showFilter: false,
                    // quickFilterProps: { debounceMs: 500 },
                },
            }}
            pageSizeOptions={[20, 25]}
            sx={gridSxStyle}
        >
            <GridToolbarQuickFilter />
        </DataGrid>
    );
});

export default TrackGrid;
